export const createFilters = (productTags) => {
  return productTags.reduce((acc, curr) => {
    curr.forEach((item) => {
      const [key, val] = item.split(":");
      const value = val?.replace(/[^a-zA-Z0-9]+/, "_");
      if (
        key === "colour_primary" ||
        key.includes("colour_secondary") ||
        key === "gender" ||
        key === "liv-bikes" ||
        key === "Shorts & Tights" ||
        key === "product_collection" ||
        key === "product_grouping" ||
        key === "product_title" ||
        key === "sizeissue" ||
        key === "technology"
      )
        return;
      if (key in acc) {
        if (!acc[key].options.includes(value)) {
          acc[key].options.push(value);
        }
        acc[key].counts[value] = (acc[key].counts[value] || 0) + 1; // increment count for this value
      } else {
        acc[key] = {
          options: [value],
          counts: { [value]: 1 }, // initialize count for this value
        };
      }
    });
    return acc;
  }, {});
};

export function numberWithCommas(x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}